<template>
  <div>
    <div v-if="showPerPage" class="row">
      <div class="col-md-2" style="padding-bottom: 10px;">
        <label>Per page</label>
        <el-select
          v-model="perPage"
          @change="dropPagination(); loadResources()"
          placeholder="Select transaction type">
          <el-option value="10" label="10"></el-option>
          <el-option value="15" label="15"></el-option>
          <el-option value="20" label="20"></el-option>
          <el-option value="25" label="25"></el-option>
          <el-option value="50" label="50"></el-option>
          <el-option value="100" label="100"></el-option>
        </el-select>
      </div>
    </div>

    <table :id="resourceName + '-table'" class="table table-striped">
      <thead>
        <tr>
          <th
            v-for="field in fields"
            @click="sort(field)"
            v-bind:class="[sorting == getSortFieldName(field) ? sortingType : '']">
            <span
              v-bind:class="[field.sort ? 'sortable' : '']">
              {{ field.label }}
            </span>
          </th>
          <th v-if="!actionsList">Actions</th>
        </tr>
      </thead>
      <tbody v-if="resources.length">
        <tr v-for="resource in resources">
          <td v-for="field in fields">
            <img
              v-if="field['img'] !== undefined && field['img']"
              :src="recValue(resource, field.name)"
            />
            <span v-else-if="field['img'] !== undefined && field['img']">
              -
            </span>
            <span v-else-if="field['money'] !== undefined && field['money']">
              {{ toMoney(recValue(resource, field.name), resource['currency']) }}
            </span>
            <span v-else-if="field['datetime'] !== undefined && field['datetime']">
              {{ formatDateTime(recValue(resource, field.name)) }}
            </span>
            <span v-else-if="field['url'] !== undefined && field['url']">
              <a :href="recValue(resource, field.name)" target="_blank">{{ recValue(resource, field.name) }}</a>
            </span>
            <span v-else-if="field['datetimeSec'] !== undefined && field['datetimeSec']">
              {{ formatDateTime(recValue(resource, field.name), true) }}
            </span>
            <span v-else-if="field['date'] !== undefined && field['date']">
              {{ formatDate(recValue(resource, field.name)) }}
            </span>
            <span v-else-if="field['decorators'] !== undefined">
              <span :class="field['decorators']['classes'][recValue(resource, field.name)]">{{ field['decorators']['values'][recValue(resource, field.name)] }}</span>
            </span>
            <span v-else-if="field['blockLabel'] !== undefined">
              {{ recValue(resource, field.name) }}
              <span class="red-tag" v-if="!resource.active">(blocked)</span>
            </span>
            <span v-else>
              {{ recValue(resource, field.name) }}
            </span>
          </td>
          <td v-if="!actionsList">
            <span v-if="!contactsList">
              <span v-for="route in actionRoutes">
                &nbsp;&nbsp;&nbsp;
                <router-link
                  v-if="route.returnId === undefined || !route.returnId"
                  :to="{ name: route.name, params: generateObj(route.idName, resource.id)}">{{ route.label }}</router-link>
                  <a v-else href="#" @click.prevent="returnId(route.name, resource.id)">
                    {{ route.label }}
                  </a>
              </span>
            </span>
            <span v-else>
              <span v-for="route in actionRoutes">
                &nbsp;&nbsp;&nbsp;<router-link
                  :to="{ name: route.name, params: { contact_id: resource.id }}">{{ route.label }}</router-link>
              </span>
            </span>
            
            
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td :colspan="fields.length + 1" class="text-center">
            No data
          </td>
        </tr>
      </tbody>
    </table>
    <div v-show="pagination.pages > 1" class="pagination">
      <span
        v-for="page in pagination.pages"
        v-bind:class="{ active: page == pagination.currentPage }"
        @click="paginate(page)">
          {{ page }}
      </span>
    </div>
  </div>
</template>

<script>
import { getList } from '@/services/__common.service'
import helpers from '@/helpers'

export default {
  name: 'resource-list',
  props: {
    url: {
      required: true,
      type: String
    },
    resourceName: {
      required: true,
      type: String
    },
    actionRoutes: {
      required: true,
      type: Array
    },
    currentSort: {
      required: true,
      type: String
    },
    initSortType: {
      required: false,
      type: String,
      default: 'desc'
    },
    fields: {
      required: true,
      type: Array
    },
    filters: {
      required: true,
      type: Object
    },
    showInQuery: {
      required: false,
      type: Array,
      default () {
        return []
      }
    },
    contactsList: {
      type: Boolean,
      default: false
    },
    actionsList: {
      type: Boolean,
      default: false
    },
    showPerPage: {
      type: Boolean,
      default: true
    },
    initPage: {
      type: String,
      default: '1'
    },
    initPerPage: {
      type: String,
      default: '10'
    },
    storagePrfx: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      resources: [],
      pagination: {
        pages: [],
        currentPage: this.initPage,
        total: null
      },
      perPage: this.initPerPage,
      sortingType: this.initSortType,
      sorting: this.currentSort
    }
  },
  mounted () {
    for (let key in this.actionRoutes) {
      if (this.actionRoutes[key].idName === undefined) {
        this.actionRoutes[key].idName = 'id'
      }
    }

    this.loadResources()
  },
  watch: {
    filters: {
      handler (val) {
        this.dropPagination()
        this.loadResources()
      },
      deep: true
    }
  },
  methods: {
    toMoney: helpers.toMoney,
    formatDate: helpers.formatDate,
    formatDateTime: helpers.formatDateTime,
    loadFromQueryParams: helpers.loadFromQueryParams,

    getList: getList,

    recValue (resource, fieldName) {
      var finalValue

      if (Array.isArray(fieldName)) {
        finalValue = resource[fieldName[0]]

        for (let key in fieldName) {
          if (key !== '0') {
            finalValue = finalValue[fieldName[key]]
          }
        }
      } else {
        finalValue = resource[fieldName]
      }

      return finalValue
    },
    generateObj (key, value) {
      let res = {}
      res[key] = value
      return res
    },
    updateQueryParams () {
      let params = {}

      Object.keys(this.filters).forEach(key => {
        let filter = this.filters[key]

        if (filter instanceof Date) {
          filter = filter.toJSON()
        }

        if (this.showInQuery.indexOf(key) !== -1) {
          if (typeof filter !== 'undefined') {
            params[key] = filter
          } else {
            params[key] = ''
          }
        } else {
          if (this.storagePrfx.length) {
            if (typeof filter !== 'undefined') {
              localStorage.setItem(this.storagePrfx + key, filter)
            } else {
              localStorage.setItem(this.storagePrfx + key, '')
            }
          }
        }
      })

      if (this.showInQuery.indexOf('page') !== -1) {
        params['page'] = this.pagination.currentPage
      } else {
        if (this.storagePrfx.length) {
          localStorage.setItem(this.storagePrfx + 'page', this.pagination.currentPage)
        }
      }
      if (this.showInQuery.indexOf('per_page') !== -1) {
        params['per_page'] = this.perPage
      } else {
        if (this.storagePrfx.length) {
          localStorage.setItem(this.storagePrfx + 'per_page', this.perPage)
        }
      }

      this.$router.push({query: params})
    },
    loadResources () {
      this.getList(this.url, this.sorting, this.sortingType, this.filters, true, this.pagination.currentPage, this.perPage).then((response) => {
        this.resources = response.data['results']
        this.pagination['total'] = response.data['count']
        this.pagination['pages'] = Math.ceil(response.data['count'] / this.perPage)
        this.updateQueryParams()

        this.$emit('total', this.pagination['total'])

        if (this.pagination['total'] > 0) {
          this.$emit('first-id', this.resources[0].id)
        }
      })
    },
    returnId (name, id) {
      this.$emit(name, id)
    },
    dropPagination () {
      this.pagination.currentPage = 1
    },
    paginate: function (page) {
      if (page !== this.pagination.currentPage) {
        this.pagination.currentPage = page
        this.loadResources()
      }
    },
    getSortFieldName (field) {
      let fieldName

      if (field.sortFieldName === undefined) {
        fieldName = field.name
      } else {
        fieldName = field.sortFieldName
      }

      return fieldName
    },
    sort (field) {
      if (field.sort) {
        let fieldName = this.getSortFieldName(field)

        if (this.sorting === fieldName) {
          this.sortingType = this.sortingType === 'desc' ? 'asc' : 'desc'
        } else {
          this.sortingType = 'desc'
        }
        this.sorting = fieldName
        this.loadResources()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ResourceList.vue?6febaac9